/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const availableCountryResponseSchema = z.object({
  countryCode: z.string(),
  name: z.string(),
});
